
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import HomeIdeasPlaceInfo from './HomeIdeasPlaceInfo.vue';
  import {getTestPlaces, TestPlace} from '@/models/test-place.model';

  @Component({
    components: {
      HomeIdeasPlaceInfo
    }
  })
  export default class HomeIdeasPlaceStart extends Vue {
    places!: TestPlace[];

    created() {
      this.places = getTestPlaces;
    }
  }
